import {FC} from 'react'
import {Trans, useTranslation} from '@/translations/i18n.tsx'
import {Assignment} from '@features/assignment/types.ts'

const buildFloorPlanFormUrl = (listingExternalId: string) => {
    const id = encodeURIComponent(listingExternalId)
    return `https://airtable.com/appRXCOlpwNYOnL6x/pag1n6wbCFU3rE4yr/form?prefill_listing_id=${id}&prefill_listing_id_vi=${id}&hide_listing_id=true`
}

export const ThreeDScanReminderCard: FC<{assignment: Assignment}> = ({assignment}) => {
    const {t} = useTranslation()
    const floorPlanFormUrl = buildFloorPlanFormUrl(assignment.entity.external_id)

    return (
        <div className="flex flex-col gap-2 p-6 bg-white border border-neutral-300 rounded-xl md:rounded-2xl w-full">
            <h3 className="text-lg font-medium text-neutral-900">{t('floor_plan:title')}</h3>
            <p className="text-md text-neutral-900 [&_a]:text-purple-700 [&_a]:font-medium [&_a]:underline [&_a]:cursor-pointer">
                <Trans
                    i18nKey={'assignment:three_d_scan:reminder_description'}
                    components={{
                        1: <a href={floorPlanFormUrl} target={'_blank'} rel={'noopener noreferrer'} />
                    }}
                />
            </p>
        </div>
    )
}
